import { useEffect } from 'react';

import { AbstractPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { useToggler } from '@/components/shared/hooks/useToggler';

export const usePaymentMethodCardConfiguration = (paymentMethodEntity: AbstractPaymentMethod) => {
  const { isOpen, setIsOpen, toggle } = useToggler();

  useEffect(() => {
    setIsOpen(false);
  }, [paymentMethodEntity.isSelected]);

  return { isConfigurationOpen: isOpen, toggleConfiguration: toggle };
};
